<template>
  <Accordion title="Dados da Correção">
    <Grid cols-4 gap-5 class="mb-5">
      <InputNumber :modelValue="correction.id" disabled label="Código" />
      <InputText modelValue="Correção" label="Tipo" disabled />
      <InputDateTime :modelValue="correction.date" label="Data" disabled />
      <InputZoom disabled label="Responsável" :modelValue="correction.idUser" database="user" item-value="id" item-text="name" placeholder="Responsável" />
    </Grid>

    <TableFull v-model="tableControl" dense offline disablePagination disableOrder :headers="itemsHeader" :items="correctionItems">
      <template #quantity="{ item }">
        <InputNumber :modelValue="item.quantity" dense disabled />
      </template>
      <template #newValue="{ item }">
        <InputNumber :modelValue="item.newValue" dense disabled />
      </template>
      <template #difference="{ item }">
        {{ item.differenceLabel }}
      </template>
      <template #price="{ item }">
        <InputMoney :modelValue="item.price" dense disabled />
      </template>
      <template #total="{ item }">
        {{ item.price == null ? '-' : ((Number(item.newValue) || 0) * Number(item.price)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
      </template>
    </TableFull>

    <TextArea class="mt-5" :modelValue="correction.description" label="Motivo" rows="4" disabled />
  </Accordion>
</template>

<script setup>
/* global defineProps */
import { computed, ref, watch } from 'vue'

const props = defineProps({
  modelValue: Object,
})

const correction = computed(() => props.modelValue || {})

const tableControl = ref({
  page: 1,
  total: 0,
  limit: 10,
  pages: 1,
  order: [],
})

const correctionItems = computed(() => {
  const originalItems = correction.value.originalMovement?.items || []
  const correctedItems = correction.value.items || []
  const correctionByItem = new Map(correctedItems.map((item) => [Number(item.idItem), item]))
  const originalIds = new Set(originalItems.map((item) => Number(item.idItem)))

  const originalRows = originalItems.map((originalItem) => {
    const correctedItem = correctionByItem.get(Number(originalItem.idItem))
    const difference = Number(correctedItem?.quantity) || 0

    return {
      ...originalItem,
      ...correctedItem,
      code: correctedItem?.code || originalItem.code,
      name: correctedItem?.name || originalItem.name,
      newValue: (Number(originalItem.quantity) || 0) + difference,
      differenceLabel: difference === 0 ? '-' : difference > 0 ? `+${difference}` : `${difference}`,
      isAddedItem: false,
    }
  })

  const addedRows = []
  correctedItems.forEach((correctedItem) => {
    if (originalIds.has(Number(correctedItem.idItem))) return
    const difference = Number(correctedItem.quantity) || 0
    addedRows.push({
      ...correctedItem,
      quantity: difference,
      newValue: difference,
      differenceLabel: difference > 0 ? `+${difference}` : `${difference}`,
      isAddedItem: true,
    })
  })

  const changedOriginalRows = originalRows.filter((item) => item.differenceLabel !== '-')
  return [...changedOriginalRows, ...addedRows]
})

const additionOnly = computed(() =>
  correctionItems.value.length > 0 && correctionItems.value.every((item) => item.isAddedItem),
)
const isEntryCorrection = computed(() => correction.value.originalMovement?.type === 'entry')

const itemsHeader = computed(() => {
  const base = [
    { title: 'Código', field: 'code', width: '180px' },
    { title: 'Item', field: 'name' },
    { title: 'Und Medida', field: 'criterionOfMeasurementSymbol', width: '120px' },
  ]
  if (additionOnly.value) {
    base.push({ title: 'Quantidade', field: 'quantity', width: '180px' })
  } else {
    base.push(
      { title: 'Novo Valor', field: 'newValue', width: '180px' },
      { title: 'Corrigido', field: 'difference', width: '180px' },
    )
  }
  if (isEntryCorrection.value) {
    base.push(
      { title: 'Preço Und', field: 'price', width: '160px' },
      { title: 'Total', field: 'total', width: '160px' },
    )
  }
  return base
})

watch(
  () => correctionItems.value.length,
  (length) => {
    tableControl.value.total = length
    tableControl.value.limit = length || 10
    tableControl.value.pages = 1
  },
  { immediate: true },
)
</script>
